import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {AuthProvider} from "./context/AuthContext";
import {LoadingProvider} from "./context/LoadingContext";
import {SnackbarProvider} from "./context/SnackBarContext";
import AuthorizationRoute from "./route/AuthorizationRoute";
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";

ReactDOM.render(
    <React.Fragment>
        <AuthProvider>
            <LoadingProvider>
                <SnackbarProvider>
                    <BrowserRouter>
                        <AuthorizationRoute>
                            <DevSupport ComponentPreviews={ComponentPreviews}
                                        useInitialHook={useInitial}
                            >
                                <App/>
                            </DevSupport>
                        </AuthorizationRoute>
                    </BrowserRouter>
                </SnackbarProvider>
            </LoadingProvider>
        </AuthProvider>
    </React.Fragment>,
    document.getElementById('root')
);
